<template>
  <div style="width: 100%;height: calc(100% - 7.2rem);" >
    <el-row style="height:  100%">
      <el-col :span="12" style="height: 100%;background-color: #FFFFFF">
        <div class="chartDiv" v-if="showRain">
          <div ref="rainChart"  class="chartStyle"></div>
        </div>
        <div :class="showRain ? 'chartDiv' : 'chartStyle'" >
          <v-chart :key="chartKey" class="chartStyle"  ref="detailChart" :option = "{
                     tooltip: {
                      trigger: 'axis',
                      confine: true,
                      axisPointer: {
                          type: 'cross',
                      },
                    },

                    color: colorData,
                    legend: {
                      data: legendData
                    },
                    grid: grid,
                    xAxis: {
                      boundaryGap: false,
                      type: 'category',
                      axisTick: {
                        alignWithLabel: true,
                      },
                      data: xAxis
                      // boundaryGap: false

                    },
                    yAxis: yAxisColumn,
                    series: seriesData
            }" ></v-chart>
        </div>
      </el-col>
      <el-col :span="12" style="height: 100%;background-color: #FFFFFF">
        <div class="showData">
          <div ref="tableDiv" class="tableDiv">
            <el-table
                :data="tableData"
                height="calc(100% - 1rem)"
                border
                size="small"
                :header-cell-style="{textAlign:'center'}"
                >
<!--              <el-table-column-->
<!--                  property="hycnnm"-->
<!--                  label="水工建筑物"-->
<!--              >-->
<!--              </el-table-column>-->
              <el-table-column
                  property="mpcd"
                  label="测点编号"
                  align="center"
                  min-width="150"
              >
              </el-table-column>
              <el-table-column
                  property="dt"
                  label="测量时间"
                  align="center"
                  min-width="130"
              >
              </el-table-column>

              <el-table-column
                  v-for="(item,index) in columns"
                  :key="item.property+'-'+index"
                  :property="item.property"
                  :label="item.label"
                  :min-width="item.width ? item.width : undefined"
              >
                <template slot-scope="scope">
                    <span :style="{'width':'100%','display': 'flex','justify-content':'flex-end','color': scope.row[item.property] ?
                    item.trend ?
                      scope.row[item.trend] ?
                      scope.row[item.trend] > 0 ?
                      '#fd1553' :
                      scope.row[item.trend] < 0 ?
                      '#15bffd' : '#000' : '#000'
                      :'#000'
                      :'#000'}"
                    >{{ scope.row[item.property] ? scope.row[item.property] : '' }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pageStyle">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
                :page-sizes="[20, 30, 40, 50, 100]"
                :page-size="params.size"
                :current-page="params.current"
                layout="total, prev, pager, next,sizes, jumper"
                :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script setup>
import VChart from "vue-echarts";
import {use} from "echarts/core";
import {LineChart,BarChart } from "echarts/charts";
import {CanvasRenderer} from "echarts/renderers";
import {GridComponent, LegendComponent, ToolboxComponent, TooltipComponent,} from "echarts/components";
const grids = {
  '0601': {
    showRain: true,
    showRsvr: true,
    rsvr:{
      initYaxis: false,
      position: undefined,
    },
    // show: true,
    grid: {
      left: ' 5%',
      right: '5%',
      bottom: '11%',
      top: '11%',
    }
  },
  '0602':{
    showRain: true,
    showRsvr: true,
    rsvr:{
      initYaxis: false,
      position: undefined,
    },
    // show: true,
    grid: {
      left: ' 5%',
      right: '5%',
      bottom: '11%',
      top: '11%',
    }
  },
  '0603':{
    showRsvr: false,
    showRain: true,
    rsvr:{
      initYaxis: true,
      position: 'right',
      offset: 50
    },
    // show: true,
    grid: {
      left: ' 5%',
      right: '5%',
      bottom: '11%',
      top: '11%',
    }
  },
  '0604':{
    showRain: false,
    showRsvr: false,
    rsvr:{
      initYaxis: true,
      position: 'right',
      offset: 0
    },
    // show: true,
    grid: {
      left: ' 5%',
      right: '5%',
      bottom: '11%',
      top: '11%',
    }
  },
  '0605':{
    showRain: false,
    showRsvr: false,
    rsvr:{
      initYaxis: true,
      position: 'right',
      offset: 0
    },
    // show: true,
    grid: {
      left: ' 5%',
      right: '5%',
      bottom: '11%',
      top: '11%',
    }
  },
  '0606':{
    showRain: false,
    showRsvr: false,
    rsvr:{
      initYaxis: true,
      position: 'right',
      offset: 0
    },
    // show: true,
    grid: {
      left: ' 5%',
      right: '5%',
      bottom: '11%',
      top: '11%',
    }
  }

};
const tableColumns = {
  '0602':[
    {'property': 'avSpprwl',label: '水位(m)',trend:'trend',width: 130},
    {'property': 'wt',label: '温度(℃)',trend:false,width: 100},
    {'property': 'mxSpprwl',label: '最高水位(mm)',trend:false,width: 145},
    {'property': 'mxMstm',label: '最高水位时间',trend:false,width: 200},
    {'property': 'mnSpprwl',label: '最低水位(mm)',trend:false,width: 130},
    {'property': 'mnMstm',label: '最低水位时间',trend:false,width: 200},
  ],
  '0601':[{'property': 'avPztbwl',label: '水位(m)',trend:'trend',width: 106},
    // {'property': 'rwater',label: '实际水深(m)',needTreed:false,width: undefined},
    {'property': 'wt',label: '温度(℃)',trend:false,width: 100},
    {'property': 'mxPztbwl',label: '最高水位(m)',trend:false,width: 130},
    {'property': 'mxMstm',label: '最高水位时间',trend:false,width: 200},
    {'property': 'mnPztbwl',label: '最低水位(m)',trend:false,width: 130},
    {'property': 'mnMstm',label: '最低水位时间',trend:false,width: 200},],
  '0603':[{'property': 'avStn',label: '应变(10⁻⁶)',trend:'trend',width: 130},
    {'property': 'wt',label: '温度（℃）',trend:false,width: 100},
    {'property': 'mxStn',label: '最大应变(10⁻⁶)',trend:false,width: 130},
    {'property': 'mxMstm',label: '最大应变时间',trend:false,width: 200},
    {'property': 'mnStn',label: '最小应变(10⁻⁶)',trend:false,width: 130},
    {'property': 'mnMstm',label: '最小应变时间',trend:false,width: 200},],
  '0604':[{'property': 'avXhdrs',label: '位移(mm)',trend:'xTrend',width: 130},
    {'property': 'wt',label: '温度(℃)',trend:false,width: 100},
    {'property': 'mxXhdrs',label: '最大位移(mm)',trend:false,width: 130},
    {'property': 'mxXmstm',label: '最大位移时间',trend:false,width: 200},
    {'property': 'mnXhdrs',label: '最小位移(mm)',trend:false,width: 130},
    {'property': 'mnXmstm',label: '最小位移时间',trend:false,width: 200},
    ],
  '0605':[
    {'property': 'avYhdrs',label: '位移(mm)',trend:'yTrend',width: 130},
    {'property': 'wt',label: '温度(℃)',trend:false,width: 100},
    {'property': 'mxYhdrs',label: '最大位移(mm)',trend:false,width: 130},
    {'property': 'mxYmstm',label: '最大位移时间',trend:false,width: 200},
    {'property': 'mnYhdrs',label: '最小位移(mm)',trend:false,width: 130},
    {'property': 'mnYmstm',label: '最小位移时间',trend:false,width: 200}],
  '0606':[{'property': 'avVrds',label: '位移(mm)',trend:'trend',width: 130},
    {'property': 'wt',label: '温度(℃)',trend:false,width: 130},
    {'property': 'mxVrds',label: '最大位移(mm)',trend:false,width: 130},
    {'property': 'mxMstm',label: '最大位移时间',trend:false,width: 200},
    {'property': 'mnVrds',label: '最小位移(mm)',trend:false,width: 130},
    {'property': 'mnMstm',label: '最小位移时间',trend:false,width: 200},],
};
use([
  BarChart,
  CanvasRenderer,
  GridComponent,
  TooltipComponent,
  LineChart,
  ToolboxComponent,
  LegendComponent,
]);
export default {
  name:'daily',
  components: {VChart},
  data() {
    return {
      barChart: null,
      chartKey: 0,
      tableKey: 0,
      tableData: [],
      dateTime: [],
      columns: [],
      chartCols:[],
      colorData:[],
      legendData:[],
      rainData: [],
      mpcd: '',
      type: '',
      xAxis: [],
      grid:{},
      seriesData: [
        {
          name: '数值（m³/h）',
          type: 'line',
          yAxisIndex: 0,
          data: [],
          smooth: true,
          showSymbol: false, //去除面积图节点圆
        },
      ],
      params:{current: 1,size: 20},
      total: 0,
      yAxisColumn: [
        {
          type: 'value',
          name: '数值',
          position: 'left',
        }
      ],
      loading: false,
      showRain: true,
      rsvr: {},
      min: null,
      max: null,
      showRsvr: false
    }
  },
  methods: {
    changLoading(loading){
      this.loading = loading;
    },
    changeMpcd(mpcd){
      this.mpcd = mpcd;
    },
    changeTime(time){
      this.dateTime = time;
    },
    addResize(){
      window.addEventListener("resize", this.onWindowResize, false);
    },
    cancelResize(){
      window.removeEventListener("resize",this.onWindowResize);
    },
    onWindowResize(){
      if(this.barChart) {
        this.chartKey++;
        this.barChart.resize();
      }
    },
    handleSizeChange(size){
      this.params.size = size;
      this.loading = true;
      this.queryData(this.type,this.mpcd,this.dateTime,this.changLoading);
    },
    handlePageChange(page){
      this.params.current = page;
      this.loading = true;
      this.queryData(this.type,this.mpcd,this.dateTime,this.changLoading);
    },
    initCharts(){
        const rainChart = this.$refs.rainChart;
        if(rainChart) {
          if(!this.barChart) {
            this.barChart = this.$echarts.init(rainChart);
          }
          const option = {
            color: ['#24bd8a'],
            tooltip: {
              //鼠标悬停提示内容
              trigger: 'axis',
              axisPointer: {
                type: 'cross',
              },
            },
            grid:{
              left: ' 5%',
              right: '5%',
              bottom: '3%',
              top: '11%',
            },
            legend: {
              data: ['降雨量(mm)']
            },
            xAxis: {
              type: 'category',
              data: this.xAxis,
              axisTick: {
                // show: false  // 是否显示刻度线
                alignWithLabel: true,
              },
              position: 'top'
            },
            yAxis: [
              {
                type: 'value',
                name: '降雨量（mm）',
                alignTicks: true,
                axisLine: {
                  show: true,
                },
                axisLabel: {
                  formatter: '{value}',
                },
                inverse: true
              }
            ],
            series: [
              {
                name: '雨量',
                type: 'bar',
                data: this.rainData,
                barWidth: 14, // 柱状图的宽度
                itemStyle: {
                  color: '#0675e9',
                }
              }]
          }
          this.barChart.setOption(option);
          this.barChart.resize();
        }
    },
    initChartYAxis(columns,datas,rsvrData){
      let i = 0;
      const ys = [];
      const seris = [];
      const colors = [];
      const legends = [];
      for(let col of columns){
        if(!col.needChart){
          continue;
        }
        let offset = 0;
        if(col.offset){
          offset = col.offset;
        }
        colors.push(col.lineColor);
        legends.push(col.label + col.dw);
        if(this.min && col.needMaxMin) {
          const yAxis = {
            type: 'value',
            name: col.label + col.dw,
            position: col.yPosition,
            alignTicks: true,
            offset: offset,
            axisLine: {
              show: true,
              lineStyle: {
                color: col.lineColor,
              },
            },
            min: this.min,
            max: this.max,
            axisLabel: {
              formatter: '{value}',
            },
          };
          ys.push(yAxis);
        }else {
          const yAxis = {
            type: 'value',
            name: col.label + col.dw,
            position: col.yPosition,
            alignTicks: true,
            offset: offset,
            axisLine: {
              show: true,
              lineStyle: {
                color: col.lineColor,
              },
            },
            axisLabel: {
              formatter: function(value) {
                    return parseFloat(value).toFixed(0);
              },
            },
          };
          ys.push(yAxis);
        }
        let data = [];
        if(datas && datas[col.bh]){
          data = datas[col.bh];
        }
        const seri = {
          name: col.label ,
          type: col.chartType,
          yAxisIndex: i,
          data: data,
          smooth: true,
          showSymbol: false, //去除面积图节点圆
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: col.lineColor,
                },
                {
                  offset: 1,
                  color: col.lineColorStop,
                },
              ],
              global: false,
            },
          },
        };
        seris.push(seri);
        i++;
      }
        if(this.showRsvr) {
          if(this.rsvr.initYaxis) {
            const yRsvr = {
              type: 'value',
              name: '库水位(m)',
              position: this.rsvr.position,
              alignTicks: true,
              offset: this.rsvr.offset,
              axisLine: {
                show: true,
                lineStyle: {
                  color: '#79CDCD',
                },
              },
              axisLabel: {
                formatter: '{value}',
              },
            };
            ys.push(yRsvr);
          }else {
            i = 0;
          }
          const rsvrSe = {
            name: '库水位（m）',
            type: 'line',
            yAxisIndex: i,
            data: rsvrData,
            smooth: true,
            showSymbol: false,
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: '#79CDCD',
                  },
                  {
                    offset: 1,
                    color: '#FFF',
                  },
                ],
                global: false,
              },
            },
          };
          colors.push('#79CDCD');
          legends.push('库水位（m）');
          seris.push(rsvrSe);
        }
      // }

      this.yAxisColumn = ys;
      this.seriesData = seris;
      this.colorData = colors;
      this.legendData = legends;
      this.chartKey++;
    },
    queryRainData(dayRainParams){
      this.request.get('/rm-drain/v1/res/rain',{params:dayRainParams}).then((rainRes)=> {
        if(rainRes.ok){
          this.rainData = rainRes.data;
          this.initCharts();
        }else{
          this.$message.error(rainRes.error.message);
        }
      });
    },
    initCondition(columns,type,mpcd,dateTime){
      this.chartCols = columns;
      this.columns = tableColumns[type];
      const gridData = grids[type];
      this.grid = gridData.grid;
      this.showRain = gridData.showRain;
      if(!gridData.showRain && this.barChart){
        this.barChart = null;
      }
      this.showRsvr = gridData.showRsvr;
      this.rsvr = gridData.rsvr;
      this.changeMpcd(mpcd);
      this.type = type;
      this.changeTime(dateTime);
      // this.chartKey++;
    },
    queryData(type,mpcd,dateTime,onChange){
      const dayRainParams = {dtGT:dateTime[0],dtLE:dateTime[1]};
      const chartParams = {mstp: type,mstmGE:dateTime[0],mstmLE:dateTime[1],mpcd:mpcd};
      const params = {mstp: type,mstmGE:dateTime[0],mstmLE:dateTime[1],mpcd:mpcd,current: this.params.current,size: this.params.size};
      this.request.post('/rm-dpzwl/queryDsj',params).then((res)=> {
        if(res.ok){
          this.tableData = res.data.records;
          this.total = res.data.total;
        }else {
          this.$message.error(res.error.message);
        }
      });
      this.request.post('/rm-dpzwl/queryDQxt',chartParams).then((res)=> {
        if(res.ok){
          const data = res.data;
          if(data) {
            this.xAxis = data.dateList;
            const minDq = data.min ? parseFloat(data.min) : false;
            const maxDq = data.max ? parseFloat(data.max) : false;
            if(this.showRain) {
              this.queryRainData(dayRainParams);
            }
            if(this.showRsvr) {
              this.request.get('/rm-drsvr/v1/res/rsvr', {params: dayRainParams}).then((rsvrRes) => {
                if (rsvrRes.ok) {
                  const rsvrData = rsvrRes.data;
                  const chartData = rsvrData.data;
                  const max = rsvrData.max ? parseFloat(rsvrData.max) : false;
                  const min = rsvrData.min ? parseFloat(rsvrData.min) : false;
                  if(maxDq && minDq) {
                    if(max && min) {
                      if (max > minDq) {
                        this.max = Math.ceil(max);
                      } else {
                        this.max = Math.ceil(maxDq);
                      }
                      if (min > minDq) {
                        this.min = Math.floor(minDq);
                      } else {
                        this.min = Math.floor(min);
                      }
                    }else{
                      this.max = Math.ceil(maxDq);
                      this.min = Math.floor(minDq);
                    }
                  }else {
                    if(max && min) {
                      this.max = Math.ceil(max);
                      this.min = Math.floor(min);
                    }
                  }
                  this.initChartYAxis(this.chartCols, data, chartData);
                  onChange(false);
                } else {
                  if(minDq && maxDq) {
                    this.min = Math.floor(minDq);
                    this.max = Math.ceil(maxDq);
                  }
                  this.initChartYAxis(this.chartCols, data, false);
                  this.$message.error(rsvrRes.error.message);
                  onChange(false);
                }
              });
            }else {
              if(minDq && maxDq) {
                this.min = Math.floor(minDq);
                this.max = Math.ceil(maxDq);
              }
              this.initChartYAxis(this.chartCols, data, false);
              onChange(false);
            }
          }else{
            this.xAxis = [];
            this.rainData = [];
            this.initChartYAxis(this.chartCols,[],false);
            this.initCharts();
            onChange(false);
          }
        }else {
          this.$message.error(res.error.message);
        }
      })
    },
  }
}
</script>
<style scoped>

.showData{
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.activeButton{
  background-color: #409EFF;
  border-color: #409EFF;
}
.normalButton{
  background-color: #ecf5ff;
  border-color: #b3d8ff;
  color: #409eff;
}
.chartDiv{
  width: 100%;
  height: 50%;
}
.chartStyle{
  width: 100%;
  height: 100%;
}

.pageStyle{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.tableDiv{
  width: 100%;
  height: calc(100% - 3.2rem);
}
</style>
